import React, { useRef } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { usePlayTarget } from './usePlayTarget';

// Thin wrappers that mark ordinary chrome as a reticle snap target (data-play).
export const PlayLink: React.FC<LinkProps> = (props) => {
  const ref = useRef<HTMLAnchorElement>(null);
  usePlayTarget(ref);
  return <Link ref={ref} {...props} />;
};

export const PlayButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = (props) => {
  const ref = useRef<HTMLButtonElement>(null);
  usePlayTarget(ref);
  return <button ref={ref} {...props} />;
};
